<template>
	<div class="float-left mr-1">
		<span class="text-primary">
			<i
				class="fa fa-info-circle fa-lg icon-button"
				title="Mostrar Justificativa"
				@click.stop="mostrarModalMostrarJustificativa = true"
			></i>
		</span>
		<b-modal id="modalMostrarJustificativa" v-model="mostrarModalMostrarJustificativa">
			<div slot="modal-title">
				Apostilamento -
				<b-badge variant="warning">{{operacao}}</b-badge>
			</div>
			<app-detalhe2 titulo="Justificativa">
				<strong>{{ apostilamento.justificativa ? apostilamento.justificativa : 'NÃO INFORMADA' }}</strong>
			</app-detalhe2>
			<div slot="modal-footer">
				<b-button variant="secondary" @click.stop="mostrarModalMostrarJustificativa = false">Fechar</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	props: {
		apostilamento: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			mostrarModalMostrarJustificativa: false,
			operacao: 'JUSTIFICATIVA'
		}
	},

	methods: {},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
